module.exports = __webpack_public_path__ + "static/media/smilepass-logo.3c79eed0.png";